import { gql } from '@apollo/client';

export const validZip = gql`
  query validZip($zipCode: String!) {
    validZip(zipCode: $zipCode)
  }
`;

export const addressDetailQuery = gql`
  query addressDetail($address: String, $zipCode: String) {
    addressDetail(address: $address, zipCode: $zipCode) {
      city
      county
      state
    }
  }
`;
